import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import {
  CalendarEventTimesChangedEvent,
  CalendarEvent,
  CalendarEventAction,
} from 'angular-calendar';
import { startOfDay, endOfDay, isSameDay, isSameMonth } from 'date-fns';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

import {
  TableSettings,
  FieldMapItem,
  ListService,
  BackendService,
  NotificationService,
  ModalService,
  ApplicationService,
  CustomModalService,
  FieldTypeEnum,
  PathParts,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../services/backend.service';
import { MontazaService } from '../../services/montaza.service';
import { UtilServiceClient } from '../../services/util.service';
import { FormCode } from '../../enums/form-code.enum';
import { FormName } from '../../enums/form-name.enum';
import { EndpointTypes } from '../../enums/enpoint-types.enum';
import { MontazaStatusEnum } from '../../enums/montaza-status.enum';
import { MontazaTabEnum } from '../../enums/montaza-tab.enum';
import { environment } from '../../../environments/environment';
import {
  MONTAZA_PROGRAM_DATUM,
  MONTAZA_DATUM,
  MONTAZA_ZAPOCNI,
  MONTAZA_SACUVAJ,
  MONTAZA_OBRISI,
  MONTAZA_PREGLED_DANA,
  MONTAZA_UREDJIVANJE,
  MONTAZA_MONTAZA,
  MONTAZA_IZBOR_EMISIJE,
  MONTAZA_OPIS,
} from '../../constants/tooltip-messages';
import { EnumService } from '../../services/enum.service';
import { Observable } from 'rxjs/Observable';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};

@Component({
  selector: 'app-montaza',
  templateUrl: './montaza.component.html',
  styleUrls: ['../../pages/montaza/montaza.component.scss'],
})
export class MontazaComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _abortUrl: string = environment.abortUrl;

  public programFieldSettings: FieldMapItem;
  public emisijaFieldSettings: FieldMapItem;
  public datumFieldSettings: FieldMapItem;
  public opisFieldSettings;
  public spotFieldSettings: FieldMapItem;
  public spotFieldSettingsLessFilters: FieldMapItem;
  public bilbordFieldSettings: FieldMapItem;
  public vremeFieldSettings: FieldMapItem;
  public cenaFieldSettings: FieldMapItem;
  public nazivFieldSettings: FieldMapItem;
  public targetDatumFieldSettings: FieldMapItem;
  public blokFieldSettings: FieldMapItem;
  public ugovorFieldSettings: FieldMapItem;
  public brendSpicaFieldSettings: FieldMapItem;

  public showDetails = false;
  public calendarView = true;

  public emisije: any[] = [];
  public programi: any[] = [];

  public selectedProgram: any;
  public selectedDatum: any;
  public selectedEmisija: any;

  public MontazaTabEnum = MontazaTabEnum;
  public activeTab: MontazaTabEnum = MontazaTabEnum.PregledDanaTab;

  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };

  public tooltips = {
    MONTAZA_PROGRAM_DATUM,
    MONTAZA_DATUM,
    MONTAZA_OPIS,
    MONTAZA_ZAPOCNI,
    MONTAZA_SACUVAJ,
    MONTAZA_OBRISI,
    MONTAZA_PREGLED_DANA,
    MONTAZA_UREDJIVANJE,
    MONTAZA_MONTAZA,
    MONTAZA_IZBOR_EMISIJE,
  };

  get activeTabPregledDana(): boolean {
    return this.activeTab === MontazaTabEnum.PregledDanaTab;
  }

  public programChangedSubject: Subject<any> = new Subject();
  public programChanged$: Observable<
    any
  > = this.programChangedSubject.asObservable();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  selectedEvent: CalendarEvent | null = null;

  constructor(
    protected _backendService: BackendService,
    protected _notificationService: NotificationService,
    private _customModalService: CustomModalService,
    protected _modalService: ModalService,
    private _listService: ListService,
    private _rtsBackendService: RtsBackendService,
    private _montazaService: MontazaService,
    private _utilService: UtilServiceClient,
    private _applicationService: ApplicationService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private _spinner: NgxSpinnerService,
    private _enumService: EnumService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    this.getMontazaSettings();
    this.fetchProgrami();
    this.subscribeToPremestiEmisiju();
    this.subscribeToCloseTabEvent();
    this.subscribeToSacuvajMontazu();
    this.subscribeToMontazaData();
    this._enumService.fetchVrstaSpota();
    this._enumService.fetchVrstaZabrane();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    const payload: any = this.getSacuvajPayload();
    payload.token = sessionStorage.getItem('token');

    const payloadString = JSON.stringify(payload);
    navigator.sendBeacon(this._abortUrl, payloadString);
  }

  subscribeToCloseTabEvent() {
    this._applicationService.sacuvajMontazu$.subscribe(document => {
      if (document.documentId === 'Montaza' && this.showDetails) {
        this.sacuvaj();
      }
    });
  }

  subscribeToPremestiEmisiju() {
    this._subscriptions.push(
      this._montazaService.premestiEmisiju$.subscribe(() => {
        this.selectedEmisija = null;
      })
    );
  }

  subscribeToSacuvajMontazu() {
    this._subscriptions.push(
      this._montazaService.sacuvajMontazu$.subscribe(() => {
        this.onSacuvajMontazu();
      })
    );
  }

  subscribeToMontazaData() {
    this._subscriptions.push(
      this._montazaService.montazaData$.subscribe(() => {
        this._spinner.hide();
      })
    );
  }

  setActiveTab(tab: MontazaTabEnum) {
    if (this.activeTab === tab) {
      return;
    }

    this.activeTab = tab;

    if (this.selectedEmisija) {
      this._montazaService.emisijaDataSubject.next(this.selectedEmisija);
      this.fetchMontaza(false, true);
    }
  }

  getMontazaSettings() {
    const montazaSettngs = this._montazaService.getMontazaSettings();
    const montazaSettngsTable = new TableSettings(montazaSettngs, 'table');

    this.programFieldSettings = montazaSettngsTable.getFieldByName('Program');
    this.emisijaFieldSettings = montazaSettngsTable.getFieldByName(
      'EmisijaRaspored'
    );
    this.opisFieldSettings = {
      id: '',
      type: FieldTypeEnum.Input,
      dbType: 'text',
      fieldName: 'opis',
      entityType: '',
      fieldKey: 'opis',
      propertyPath: new PathParts(),
      relationKey: new PathParts([]),
      relationValue: new PathParts([]),
      path: '',
      label: 'Opis',
      mandatory: false,
      width: '',
      validator: '',
      editable: true,
      additable: true,
      title: '',
      relation: null,
      visible: true,
      editableOverride: null,
      additableOverride: null,
      lookupFilter: null,
      lookupList: [],
      multiline: true,
      decimalCount: 2,
      color: null,
      errorMessage: '',
      documentType: null,
      lookupFormCode: null,
      lookupFormName: null,
    };
    this.datumFieldSettings = montazaSettngsTable.getFieldByName('Datum');
    this.targetDatumFieldSettings = montazaSettngsTable.getFieldByName(
      'TargetDatum'
    );
    this.spotFieldSettings = montazaSettngsTable.getFieldByName('Spot');
    this.spotFieldSettingsLessFilters = montazaSettngsTable.getFieldByName(
      'SpotLessFilters'
    );

    this.vremeFieldSettings = montazaSettngsTable.getFieldByName('Vreme');
    this.cenaFieldSettings = montazaSettngsTable.getFieldByName('Cena');
    this.nazivFieldSettings = montazaSettngsTable.getFieldByName('Naziv');
    this.blokFieldSettings = montazaSettngsTable.getFieldByName('Blok');
    this.bilbordFieldSettings = montazaSettngsTable.getFieldByName('Bilbord');
    this.ugovorFieldSettings = montazaSettngsTable.getFieldByName('Ugovor');
    this.brendSpicaFieldSettings = montazaSettngsTable.getFieldByName(
      'BrendSpica'
    );
  }

  fetchProgrami() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSPRO_PRO,
          FormName.PregledProgama,
          EndpointTypes.AllEntities,
          '?vrstaMedijaId=1' // samo TV
        )
        .subscribe((data: any) => {
          this.programi = data.ServiceData.Data;
          this._listService.registerEnum(
            'MontazaProgramEnum',
            this._utilService.parseEnum(this.programi)
          );
        })
    );
  }

  setInitEmisijeFilter() {
    this.emisijaFieldSettings.lookupInitFilter = [
      { name: 'MontazaId', value: `${this._montazaService.montaza.Id}` },
    ];
  }

  setInitBrendSpicaFilter() {
    this.brendSpicaFieldSettings.lookupInitFilter = [
      { name: 'datumMontaze', value: `${this._montazaService.datum}` },
      { name: 'programId', value: `${this._montazaService.programId}` },
    ];
  }

  isDatumValid(datum: any): boolean {
    const d = moment().format('YYYY-MM-DD');
    const isValid = !moment(datum).isBefore(d);

    return isValid;
  }

  checkZapocni(): boolean {
    let valid = true;
    if (!this.selectedProgram || !this.selectedDatum) {
      this._notificationService.notyError(
        `Potrebno je prvo izabrati program i datum.`
      );

      valid = false;
    }

    // if (!this.isDatumValid(this.selectedDatum)) {
    //   this._notificationService.notyError(
    //     `Minimalan datum je ${moment().format('DD.MM.YYYY')}.`
    //   );

    //   valid = false;
    // }

    return valid;
  }

  zapocni(emisijaId?: string, emisijaVremeEmitovanja?: string) {
    if (!this.checkZapocni()) {
      return;
    }

    this._spinner.show();

    const entity = {
      ProgramId: this.selectedProgram.Id,
      ProgramNaziv: this.selectedProgram.Naziv,
      ProgramSifra: this.selectedProgram.Sifra,
      Datum: moment(this.selectedDatum).format('YYYY-MM-DD'),
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMON_ZAPM,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      null,
      entity,
      null
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          const montaza = response.ServiceData.Montaza
            ? response.ServiceData.Montaza
            : {};

          this._montazaService.setProgramId(this.selectedProgram.Id);
          this._montazaService.setDatum(this.selectedDatum);
          this._montazaService.setMontaza(montaza);

          this.setInitEmisijeFilter();
          this.setInitBrendSpicaFilter();
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }
          if (montaza.Status === MontazaStatusEnum.Idle) {
            this._spinner.hide();
            this.activate();
            this.calendarView = false;

            return;
          }
          this.calendarView = false;

          this.disableMontazaFields();
          this.showDetails = true;

          this._montazaService.montazaDataSubject.next();

          if (emisijaId != null && emisijaId != undefined && emisijaVremeEmitovanja != null && emisijaVremeEmitovanja != undefined) {
            const filter = `?pageNumber=1&pageSize=1000&MontazaId=${this._montazaService.montaza.Id}`;
            this._subscriptions.push(
              this._rtsBackendService
                .fetchSettings(
                  FormCode.MSMON_EMI,
                  FormName.Montaza,
                  EndpointTypes.AllEntities,
                  filter
                )
                .subscribe(data => {
                  var postojiEmisija: boolean = false;
                  if (data['ServiceData'] != null && data['ServiceData'].length > 0) {
                    for (var i = 0; i < data['ServiceData'].length; i++) {
                      if (data['ServiceData'][i].EmisijaId === emisijaId && data['ServiceData'][i].VremeEmitovanja === emisijaVremeEmitovanja) {
                        postojiEmisija = true;
                        this.selectedEmisija = data['ServiceData'][i];
                        this._montazaService.emisijaDataSubject.next(this.selectedEmisija);
                        this.fetchMontaza(false, false);
                      }
                    }
                  }
                  if (!postojiEmisija) {
                    this.sacuvaj();
                  }
                })
            );
          }
        })
    );
  }

  activate() {
    this._spinner.show();

    const entity = {
      Id: this._montazaService.montaza.Id,
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMON_IPST,
      FormName.Montaza,
      EndpointTypes.PutEntity,
      null,
      entity,
      null
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.showDetails = true;
          this.disableMontazaFields();
          this._montazaService.montazaDataSubject.next();
        })
    );
  }

  obrisiMontazu() {
    this._modalService.openModal(
      'Da li ste sigurni da želite da obrišete montažu?',
      res => {
        if (res) {
          this.obrisi();
        }
      }
    );
  }

  obrisi() {
    this._spinner.show();
    const entityGuids = {
      MontazaId: this._montazaService.montaza.Id,
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMON_DLT,
      FormName.Montaza,
      EndpointTypes.DeleteEntity,
      null,
      null,
      entityGuids
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._spinner.hide();
          if (this._montazaService.hasError(response)) {
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.showDetails = false;
          this.selectedEmisija = null;
          this.datumFieldSettings.editable = true;
          this._notificationService.openNoty('Montaža uspešno obrisana.');
          this.calendarView = true;
        })
    );
  }

  disableMontazaFields() {
    this.datumFieldSettings.editable = false;
  }

  fieldUpdateDate(event) {
    this.selectedDatum = moment(event.value.start).format('YYYY-MM-DD');
  }

  onSelectedEmisijaChange(event) {
    if (event.value) {
      this.selectedEmisija = event.value;
      this._montazaService.emisijaDataSubject.next(this.selectedEmisija);
      this.fetchMontaza(false, false);
    }
  }

  onSelectedProgramChange(event) {
    this.selectedProgram = this.programi.find(
      program => program.Id === event.value
    );
    this.programChangedSubject.next(this.selectedProgram);
    this.calendarView = true;
    // this.loadEvents();
  }

  fetchMontaza(fetchAll: boolean = true, updateMontaza?: boolean) {
    let filter = `?programId=${this.selectedProgram.Id}&datumMontaze=${this.selectedDatum}`;

    if (!fetchAll) {
      filter = `${filter}&emisijaRasporedId=${this.selectedEmisija.Id}`;
    }

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMON_MON,
      FormName.Montaza,
      EndpointTypes.GetAllEntities,
      filter,
      null,
      null
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (fetchAll) {
            this._montazaService.setMontaza(response.ServiceData);
          }
          this._montazaService.montazaDataSubject.next(
            updateMontaza ? response : null
          );
        })
    );
  }

  getMontazaOpis() {
    const montaza = this._montazaService.montaza;

    return montaza && montaza.Opis ? montaza.Opis : '';
  }

  onSacuvajMontazu() {
    this.showDetails = false;
    this.selectedEmisija = null;
    this.resetMontazaSettings();
    this.calendarView = true;
  }

  resetMontazaSettings() {
    this.datumFieldSettings.editable = true;
    this._montazaService.resetData();
  }

  checkSacuvaj() {
    this._modalService.openModal(
      'Da li želite da sačuvate montažu za posle?',
      res => {
        if (res) {
          this.sacuvaj();
        }
      }
    );
  }

  sacuvaj() {
    if (!this._montazaService.montaza || !this._montazaService.montaza.Id) {
      return;
    }

    const payload = this.getSacuvajPayload();

    this._rtsBackendService
      .fetchMediaPlanSettings(payload)
      .subscribe(response => {
        if (this._montazaService.hasError(response)) {
          this._notificationService.notyError(
            response['Errors'][0]['ErrorMessage']
          );

          return;
        }

        this._notificationService.openNoty(
          'Montaža uspešno sačuvana za kasnije.'
        );

        this._montazaService.sacuvajMontazuSubject.next();
      });
  }

  getSacuvajPayload() {
    return this._rtsBackendService.getRequestPayload(
      FormCode.MSMON_SMON,
      FormName.Montaza,
      EndpointTypes.PutEntity,
      null,
      this._montazaService.montaza
    );
  }

  async osveziMontazuPoslePromeneEmisije(updateObject: any) {
    if (updateObject.isProgramChanged) {
      const filter = `?pageNumber=1&pageSize=1000&MontazaId=${this._montazaService.montaza.Id}`;
        this._subscriptions.push(
          this._rtsBackendService
            .fetchSettings(
              FormCode.MSMON_EMI,
              FormName.Montaza,
              EndpointTypes.AllEntities,
              filter
            )
            .subscribe(data => {
              if (data['ServiceData'] == null || data['ServiceData'].length === 0) {
                this.sacuvaj();          
              } else {
                this.showDetails = false;
                this.selectedEmisija = null;
                this.resetMontazaSettings();
                this.zapocni();
              }
            })
        );
      
    } else {
      this.zapocni(this.selectedEmisija.EmisijaId, this.selectedEmisija.VremeEmitovanja);
    }
  }

  openModal(event: CalendarEvent) {
    this.selectedEvent = event;
    this._customModalService.open('custom-montaza-modal');
  }

  closeModal() {
    this._customModalService.close('custom-montaza-modal');
  }

  opisChanged(value: any) {
    this._montazaService.updateOpis(value);
  }

  setDatumZapocniMontazu(datum) {
    this.selectedDatum = moment(datum).format('YYYY-MM-DD');
    this.zapocni();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/montaza/montaza.component.ts